import { Ear, EarOff } from "lucide-react";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

export const ToggleProcessScript = ({
  processScript,
  handleToggleProcessScript,
}: {
  handleToggleProcessScript: () => void;
  processScript: boolean;
}) => {
  return (
    <DropdownMenuItem onClick={handleToggleProcessScript}>
      {processScript ? (
        <EarOff size={12} className="mr-2" />
      ) : (
        <Ear size={12} className="mr-2" />
      )}
      {` ${processScript ? "Disable transcript" : "Enable transcript"}`}
    </DropdownMenuItem>
  );
};
